// Toggleable/orderable columns for the All table (the #, pin and action columns
// are always shown and aren't in this list). Mirrors the Alerts column-prefs shape.
// Order = industry-standard / Stripe-style priority: the high-signal fields
// (status, customer, amount, processor, reason, deadline, date) lead and sit on
// the first fold; the rest are off by default and addable via Edit columns.
export const DEFAULT_DISPUTE_COLUMNS = [
  // "Best by default": the high-signal fields a disputes operator needs at a glance
  // lead and are visible; detail/duplicative fields are off by default and addable
  // via Edit columns. Customer name beats email, Category beats raw Reason code, and
  // the Due deadline beats the Dispute date for day-to-day triage, so those three
  // duplicates start hidden. Assignee (team workflow) is visible by default.
  { field_id: "number", label: "#", active: true },
  { field_id: "status", label: "Status", active: true },
  // Case type: Dispute vs Inquiry.
  { field_id: "dispute_type", label: "Type", active: true },
  { field_id: "enrichment", label: "Enrichment", active: true },
  // Stage is off by default (lifecycle detail, addable via Edit columns).
  { field_id: "cycle_stage", label: "Stage", active: false },
  { field_id: "reason_category", label: "Category", active: true },
  { field_id: "assignee", label: "Assignee", active: true },
  { field_id: "due_by", label: "Due", active: true },
  { field_id: "submission_status", label: "Submission", active: true },
  // Customer and Amount sit right after Submission (triage first, identity after),
  // then the dispute's own date and ID.
  { field_id: "customer_full_name", label: "Customer full name", active: true },
  { field_id: "amount", label: "Amount", active: true },
  { field_id: "dispute_created_at", label: "Dispute date", active: true },
  { field_id: "updated_at", label: "Last update", active: true },
  { field_id: "processor_dispute_id", label: "Dispute ID", active: true },
  { field_id: "processor", label: "Payment processor", active: true },
  { field_id: "customer_email", label: "Customer email", active: false },
  { field_id: "reason_code", label: "Reason code", active: false },
  { field_id: "flag_reason", label: "Flag", active: false },
  { field_id: "issuer", label: "Card network", active: false },
  { field_id: "issuing_bank", label: "Issuer", active: false },
  { field_id: "card_type", label: "Card type", active: false },
  { field_id: "card_last4", label: "Card last 4", active: false },
  { field_id: "transaction_date", label: "Transaction date", active: false },
  { field_id: "country", label: "Country", active: false },
  { field_id: "currency", label: "Currency", active: false }
]

// The filter chips shown by default: Status, Category, Customer full name, Amount,
// Dispute date. Every other chip (each one named after its table column) is added
// via "+ Add filter".
export const DEFAULT_VISIBLE_FILTERS = ["status", "reason_category", "customer", "amount", "date"]
